// WHO ACTUALLY OWNS THE PRICE — one vote per operator, not per brand.
//
// The market's fair price used to be the mean of every book on the board, one
// vote each (engine review #5). A board is not thirteen independent opinions.
// Ladbrokes and Neds are one trading room at Entain and publish the same number
// to two front doors; TAB and TABtouch are one Tabcorp feed. Counting them
// twice does not make the consensus better informed, it makes it twice as sure
// of one opinion — and the more front doors an operator runs, the more the
// average quietly becomes that operator's own line.
//
// So `consensus` gives the SOFT board one vote per operator and splits it
// between that operator's brands (`classShares`, universe.js).
//
// A LEAF WITH NO IMPORTS, and in the engine rather than beside `BOOKMAKER_SITES`
// in lib/bookmakers.js, for the reason that file gives about `odds.js`: the
// engine is read by a backtest and by a server route as well as by a screen,
// and it must not pull a module that reaches for storage on the way in. The two
// tables are held against `BOOKMAKERS` by their own tests instead, which is
// where a table and the board are allowed to know about each other.
//
// WHERE TWO BRANDS ARE THE SAME COMPANY BUT PRICE APART they are left apart.
// betr and PointsBet Australia came under one owner and still publish two
// markets; the question this map asks is "is this the same price arriving
// twice", not "is this the same shareholder". One line changes it if their
// boards converge.

/** The Odds API's bookmaker key → the operator whose trading room sets the price. */
export const OPERATOR = {
  sportsbet: 'sportsbet',
  tab: 'tabcorp',
  tabtouch: 'tabcorp',
  ladbrokes_au: 'entain',
  neds: 'entain',
  pointsbetau: 'pointsbet',
  bet365_au: 'bet365',
  unibet: 'unibet',
  betr_au: 'betr',
  playup: 'playup',
  betright: 'betright',
  dabble_au: 'dabble',
  betfair_ex_au: 'betfair',
};

/**
 * The operator behind a bookmaker key, or the key itself for one this app has
 * never heard of — an unknown book is its own independent voice, which is the
 * safe reading: it may well be, and grouping it with something else would be a
 * claim nobody made. The test pins every key the board can carry, so the
 * fallback only ever catches a historical row keyed by its own name.
 */
export const operatorOf = (key) => OPERATOR[key] ?? String(key ?? '');
